import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PlanOverview from '@dashboard/scenes/BillingSettings/scenes/Plan/PlanOverview';
import Upgrade from '@dashboard/scenes/BillingSettings/scenes/Plan/Upgrade';
import CancelSubscription from '@dashboard/scenes/BillingSettings/scenes/Plan/CancelSubscription';
import PageHeader from '@dashboard/components/PageHeader';

const SettingsPlan = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader title="Plan" description="View and manage your subscription plan." />

      <div className="mb-32">
        <Switch>
          <Route path="/settings/plan" exact>
            <PlanOverview />
          </Route>
          <Route path="/settings/plan/upgrade">
            <Upgrade />
          </Route>
          <Route path="/settings/plan/cancel">
            <CancelSubscription />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default SettingsPlan;
